// customer-satisfaction-stat.tsx — Customer satisfaction rating stat card.
import { Card, CardBody, CardTitle, Skeleton } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import { Alert } from '@vnetwork/ui/feedback';
import type { CustomerSatisfaction } from '@/api/tickets-statistics';

interface Props {
  data: CustomerSatisfaction | undefined;
  isLoading: boolean;
  isError: boolean;
}

export function CustomerSatisfactionStat({ data, isLoading, isError }: Props) {
  const avg = data?.avg_rating ?? 0;
  const dotColor =
    avg >= 4 ? 'var(--vn-success-solid)' : avg >= 3 ? 'var(--vn-warning-solid)' : 'var(--vn-danger-solid)';

  return (
    <Card flat>
      <CardBody>
        <CardTitle style={{ marginBottom: 'var(--vn-space-3)' }}>Customer Satisfaction</CardTitle>
        {isError ? (
          <Alert tone="danger" title="Failed to load satisfaction data" />
        ) : isLoading ? (
          <Skeleton style={{ height: 80 }} />
        ) : (
          <StatGroup columns={4}>
            <Stat
              label="Avg Rating"
              value={`${Number(avg).toFixed(2)} ★`}
              dotColor={dotColor}
            />
            <Stat
              label="Total Rated"
              value={(data?.total_rated ?? 0).toLocaleString('en-US')}
            />
            <Stat
              label="5-star"
              value={(data?.five_star ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-success-solid)"
            />
            <Stat
              label="1-star"
              value={(data?.one_star ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-danger-solid)"
            />
          </StatGroup>
        )}
      </CardBody>
    </Card>
  );
}
